class ConstructionConfig
{
	constructor()
	{
		this.config = null;
		this.loaded = false;
	}

	async loadConfig()
	{
		if (this.loaded) return this.config;
		
		try
		{
			const response = await fetch(`${process.env.PUBLIC_URL}/json/config.json`);
			this.config = await response.json();
			this.loaded = true;
			return this.config;
		}
		catch (error)
		{
			console.error('Failed to load construction config:', error);
			this.config = { buildings: [] };
			this.loaded = true;
			return this.config;
		}
	}

	isConstruction(itemId, itemType = 'building')
	{
		if (!this.config) return false;
		
		// Map the infoType to config type
		const typeMap = 
		{
			'site': 'building',
			'exterior': 'exterior',
			'building': 'building'
		};
		
		const configType = typeMap[itemType] || itemType;
		
		const item = this.config.buildings.find(b => 
			b.id === itemId && b.type === configType
		);
		return item ? item.is_construction === true : false;
	}
}

export default new ConstructionConfig();

